<template>
  <v-container fluid style="max-width: 1300px">
    <v-overlay :value="isLoading" v-if="isLoading" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-else>
      <v-alert
        dense
        outlined
        type="error"
        v-if="this.$store.state.Deadline != 'open'"
      >
        Accreditation Closed!
      </v-alert>
      <v-alert dense outlined type="error" v-else-if="limitStatus">
        Application Limit Exhausted!
      </v-alert>
      <v-card class="cshadow" v-if="$store.state.eventInfo.EventId == 2063">
        <v-card-actions class="font-weight-bold">
          <div>Selected Festival : {{ vData.company_phone_no }}</div>
          <v-spacer />
        </v-card-actions>
      </v-card>
      <v-row class="mt-0">
        <v-col cols="12" md="4">
          <v-card height="210px" class="cshadow">
            <v-card-text class="panHead">Event Details</v-card-text>
            <v-divider></v-divider>
            <v-card-title class="pa-0" style="font-size: 1rem">
              <v-list dense color="transparent">
                <v-list-item style="min-height: 20px">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-trophy</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $store.state.eventInfo.EventName
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item style="min-height: 20px" v-if="$store.state.eventInfo.EventId !== 2063">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-calendar-range</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $store.state.eventInfo.EventDate
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item style="min-height: 20px">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-map-marker-radius</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $store.state.eventInfo.VenueName
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item style="min-height: 20px">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-stadium-variant</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $store.state.eventInfo.StadiumName
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card height="210px" class="cshadow">
            <v-card-text class="panHead" v-if="$store.state.eventInfo.EventId == 2063">
              For Queries Contact</v-card-text
            >
            <v-card-text class="panHead" v-else>
              Event Accreditation Manager</v-card-text
            >
            <v-divider></v-divider>
            <v-card-title class="pa-0">
              <v-list dense color="transparent">
                <v-list-item style="min-height: 20px">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $store.state.eventInfo.AccredMgrName
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item style="min-height: 20px">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title
                    style="text-wrap: balance; word-break: normal"
                    >{{
                      $store.state.eventInfo.AccredMgrEmail
                    }}</v-list-item-title
                  >
                </v-list-item>
                <v-list-item style="min-height: 20px">
                  <v-list-item-icon class="mt-1 mb-1 mr-3">
                    <v-icon>mdi-cellphone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    $store.state.eventInfo.AccredMgrContact
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card height="210px" class="cshadow">
            <v-card-text class="panHead"
              >Application Deadline - {{ dData.deadline }} IST</v-card-text
            >
            <v-divider></v-divider>
            <div class="text-center mt-4">
              <Countdown
                v-if="dData.deadline"
                :deadline="dData.deadline"
              ></Countdown>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="$store.state.eventInfo.VendorLink==true">
        <v-col>
          <ShareLink />
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="6">
          <v-card height="300px" class="cshadow">
            <v-card-text class="panHead">Applications Assigned</v-card-text>
            <v-divider></v-divider>
            <Assigned
              v-if="dData.application_Summary"
              :cdata="dData.application_Summary"
            ></Assigned>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card height="300px" class="cshadow">
            <v-card-text class="panHead">Applications Received</v-card-text>
            <v-divider></v-divider>
            <Submitted
              v-if="dData.application_Status"
              :cdata="dData.application_Status"
            ></Submitted>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="6">
          <v-card height="450px" class="cshadow">
            <v-card-text class="panHead">{{
              $store.state.eventInfo.StadiumName
            }}</v-card-text>
            <v-divider></v-divider>
            <div class="text-center">
              <iframe
                v-if="dData.venue_dtl"
                :src="dData.venue_dtl.google_location"
                width="98%"
                height="390"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card height="450px" class="cshadow">
            <v-card-text class="panHead">Application Process</v-card-text>
            <v-divider></v-divider>
            <v-card-text class="py-0">
              <Howtoapply></Howtoapply>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Countdown from "../components/dashboard/countdown";
import Howtoapply from "../components/dashboard/howtoapply";
import Assigned from "../components/dashboard/assigned";
import Submitted from "../components/dashboard/submitted";
import ShareLink from "../components/dashboard/sharelink";
//import ViewSchedule from "../components/common/ViewSchedule.vue"
import "viewerjs/dist/viewer.css";

export default {
  components: { Countdown, Howtoapply, Assigned, Submitted, ShareLink },
  data() {
    return {
      dData: {},
      isLoading: false,
      limitStatus: false,
      vData: {},
    };
  },
  async mounted() {
    this.$store.commit("setPageTitle", "Dashboard");
    this.isLoading = true;
    await this.$axios
      .get("/VendorDashboard")
      .then((res) => {
        this.dData = res.data.result;
        console.log(this.dData);
        this.$store.commit("setDeadline", this.dData.deadline_Status);
        this.$store.commit("setActiveZones", this.dData.stand_id);
        if (this.dData.application_Summary[1].value <= 0) {
          this.limitStatus = true;
          this.$store.commit("setLimitOver", true);
        } else {
          this.limitStatus = false;
          this.$store.commit("setLimitOver", false);
        }
        this.isLoading = false;
      })
      .catch(function () {
        this.isLoading = false;
      });

    await this.$axios
      .get("Vendor/" + this.$store.state.eventInfo.VendorId)
      .then((res) => {
        this.vData = res.data.result;
      });
  },
};
</script>

<style scoped>
.panHead {
  padding: 10px !important;
}
.cshadow {
  box-shadow: 0 0 40px #ccc !important;
}
</style>